import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#FAF9F6] grain flex items-center justify-center px-4">
      <div className="card-pop bg-white p-10 w-full max-w-md text-center" data-testid="payment-cancel-card">
        <div className="w-16 h-16 rounded-2xl bg-amber-300 border-2 border-[#111114] flex items-center justify-center mx-auto mb-5">
          <XCircle className="w-9 h-9 text-[#111114]" />
        </div>
        <h1 className="font-display text-2xl font-extrabold mb-2">Checkout cancelled</h1>
        <p className="text-slate-600 mb-8">No worries — you weren't charged. You can come back anytime.</p>
        <Link to="/member"><Button className="bg-violet-600 text-white btn-pop rounded-full h-11 px-8 font-bold">Back to dashboard</Button></Link>
      </div>
    </div>
  );
}
